angular.module('zc.zenclerkS')

  .component('zcsDashboardWidgetCampaignListTitle', {
    templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list-title.html',
    require: {
      dashboard: '^zcsDashboardMain'
    },
    controller: zcsDashboardWidgetCampaignListTitleController
  });

zcsDashboardWidgetCampaignListTitleController.$inject = [];
function zcsDashboardWidgetCampaignListTitleController() {
  const vm = this;

  vm.$onInit = () => {
    vm.project = vm.dashboard.project;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-campaign-list-title.component.js